class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHover();
  }

  setupHover() {
    // Only enable hover on desktop (1024px and above)
    const checkDesktop = () => window.innerWidth >= 1024;
    if (!checkDesktop()) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
    
    if (!summary || !submenu) return;

    // Find parent li wrapper
    const parentLi = this.closest('.header__menu-item-wrapper');
    if (!parentLi) return;

    let closeTimeout;

    // Open on mouseenter
    const handleMouseEnter = () => {
      if (!checkDesktop()) return;
      clearTimeout(closeTimeout);
      
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        if (this.header) {
          this.header.preventHide = true;
        }
      }
    };

    // Close on mouseleave (with delay to allow moving to submenu)
    const handleMouseLeave = () => {
      if (!checkDesktop()) return;
      
      closeTimeout = setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          if (this.header) {
            this.header.preventHide = false;
          }
        }
      }, 250);
    };

    // Attach hover to parent li which contains both summary and submenu
    parentLi.addEventListener('mouseenter', handleMouseEnter);
    parentLi.addEventListener('mouseleave', handleMouseLeave);
    
    // Also attach to header-menu element as backup
    this.addEventListener('mouseenter', handleMouseEnter);
    this.addEventListener('mouseleave', handleMouseLeave);
    
    // Keep submenu open when hovering over it
    submenu.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Handle hover for nested details elements (grandchild submenus) on desktop
document.addEventListener('DOMContentLoaded', () => {
  const setupNestedHover = () => {
    // Only enable on desktop
    if (window.innerWidth < 1024) return;
    
    const nestedDetails = document.querySelectorAll('.header__submenu details.header-menu-details');
    
    nestedDetails.forEach((detailsEl) => {
      // Skip if already has hover handler
      if (detailsEl.dataset.hoverSetup === 'true') return;
      detailsEl.dataset.hoverSetup = 'true';
      
      const summary = detailsEl.querySelector('summary');
      const submenu = detailsEl.querySelector('.header__submenu');
      
      if (!summary || !submenu) return;

      let closeTimeout;
      let isHovering = false;

      const handleMouseEnter = () => {
        if (window.innerWidth < 1024) return;
        clearTimeout(closeTimeout);
        isHovering = true;
        
        if (!detailsEl.hasAttribute('open')) {
          detailsEl.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      };

      const handleMouseLeave = () => {
        if (window.innerWidth < 1024) return;
        isHovering = false;
        
        closeTimeout = setTimeout(() => {
          if (!isHovering && detailsEl.hasAttribute('open')) {
            detailsEl.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        }, 200);
      };

      detailsEl.addEventListener('mouseenter', handleMouseEnter);
      detailsEl.addEventListener('mouseleave', handleMouseLeave);
      summary.addEventListener('mouseenter', handleMouseEnter);
      submenu.addEventListener('mouseenter', handleMouseEnter);
      submenu.addEventListener('mouseleave', handleMouseLeave);
    });
  };
  
  // Setup on load
  setupNestedHover();
  
  // Re-setup when menu items are dynamically added
  const observer = new MutationObserver(() => {
    setupNestedHover();
  });
  
  const menuContainer = document.querySelector('.header__inline-menu');
  if (menuContainer) {
    observer.observe(menuContainer, { childList: true, subtree: true });
  }
});
